<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <lim-prod />
      </div>
    </div>
</section>
</template>

<script>
import limProdTemp from './Temp/LimScheduleProdTemp.vue'

export default {
  name: 'Tables',
  components: {
    'lim-prod': limProdTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrlimitedSchedule.vue?3ac8d9c4